import { getCurrentInstance } from 'vue'

type FormLib = {
  nextInput: (el: unknown) => void
  katakana2Hiragana: (text: string) => string
  zenToHanNumber: (value: string) => string
  dateFormat: (date: Date | string | undefined, format: string) => string
  getToday: () => Date
  charCount: (text: string | undefined) => number
  separatedPostNumber: (postNumber: string | undefined) => string
  addressFromZip: (
    postNumber: string,
    callback: (data: { kanji: string; kana: string }) => void
  ) => void
}

type GtmHost = {
  sendEprintEvent: (name: string, params?: Record<string, unknown>) => void
  sendEprintPurchase: (params: Record<string, unknown>) => void
  sendError: (area: string, message: string) => void
  generateFunnelSessionId: () => string
  getPrintTypeLabel: (printType: string) => string
  getPrintTypePrice: (printType: string) => number
  getStoreLabel: (storeKey: string) => string
  sendLoginPopupEvent: (
    eventName: string,
    params?: Record<string, unknown>
  ) => void
}

type MessageHost = {
  (opts: Record<string, unknown>): { close: () => void }
}

type HostVm = {
  $formLib: FormLib
  $deviceLib: { isOnline: boolean; isMobileDevice: boolean; isIE: boolean }
  $yagiprimePaymentService: {
    useFeature: (
      vm: unknown,
      feature: string,
      hooks: { onSuccess: () => void; onCancel: () => void }
    ) => void
  }
  $varuna: { endPoints: Record<string, string> }
  $globalVar: {
    isYagiPrime: boolean
    dn_flag?: string
    qmailRirekishoHtml: string
    displayFrontEndPopupRenew?: (
      formatId: string,
      formatData: object,
      basicData: object,
      otherFormatData: object,
      requestData: unknown,
      previewFormat: unknown,
      isMypage?: boolean,
      opts?: object
    ) => boolean | void
    /** アプリ内課金（ヤギのメール便など有料導線）を出すか */
    in_app_payments?: boolean
  }
  $site: {
    appFlag: string
    rirekishoFormatsIndex?: unknown
    keirekishoFormatsIndex?: unknown
    etcFormatsIndex?: unknown
  }
  $gtm: GtmHost
  $message: MessageHost
  $cookies: {
    get: (key: string) => string | undefined
    remove: (key: string) => void
    config?: (expireTimes: number | string, path?: string) => void
    set?: (
      keyName: string,
      value: unknown,
      expireTimes?: number | string | null,
      path?: string | null,
      domain?: string | null
    ) => void
  }
  $clearStorage?: () => void
}

export function useHostServices() {
  const vm = getCurrentInstance()!.proxy as unknown as HostVm
  return {
    vm,
    formLib: vm.$formLib,
    deviceLib: vm.$deviceLib,
    yagiprimePaymentService: vm.$yagiprimePaymentService,
    varuna: vm.$varuna,
    globalVar: vm.$globalVar,
    site: vm.$site,
    gtm: vm.$gtm,
    message: vm.$message,
    cookies: vm.$cookies,
    clearStorage: vm.$clearStorage
  }
}
